import { themeBaseConfig } from '@ntc/css/theme.base'
import { themeRonaConfig } from '@ntc/css/theme.rona'
import { createTheme } from '@ntc/lib/utils/theme-utils'

export type Theme = typeof theme

const themes = createTheme({
  theme: {
    // Theme base for sizing, breakpoints, etc.
    ...themeBaseConfig,
    // Default theme for Rona.ca
    ...themeRonaConfig,
    // Add custom theming here or overrides to the base or Rona default theme
    'color-alert-success': '#338700',
    'color-alert-warn': '#dda42a',
    'color-alert-error': '#c21e1eff'
  }
})

/**
 * Used in the theme provider to enforce scoping on the generated css variables
 */
export const prefixedTheme = themes.prefixedTheme

/**
 * Used in the JSX - maps the raw theme keys to their corresponding CSS variable references.
 * Used by the scripts when generating the SCSS variables.
 * NB: CSS variable prefixing is not supported by styled-modules so we are manually creating the css variable reference
 */
export const theme = themes.theme
